import httpService from "app/services/httpService";
import config from "../../../src/config.json";

// Function to get roles
export const getRoles = async () => {
  const { data } = await httpService.get(`${config.apiUrl}/authenticate/roles`);

  return data;
};

// Function to get menu by role
export const getMenuByRole = async (id) => {
  const { data } = await httpService.post(
    `${config.apiUrl}/authenticate/roles/${id}/permission`
  );
  return data;
};

// Function to update permission by role
export const updatePermissionByRole = async (id, value) => {
  const { data } = await httpService.post(
    `${config.apiUrl}/authenticate/roles/${id}/permission/update`,
    value
  );
  return data;
};

export const getUserPermission = async () => {
  const { data } = await httpService.post(
    `${config.apiUrl}/authenticate/user/permission`
  );
  return data;
};
